import { render, staticRenderFns } from "./student-policy-form.vue?vue&type=template&id=1b11b794&scoped=true&"
import script from "./student-policy-form.vue?vue&type=script&lang=js&"
export * from "./student-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./student-policy-form.vue?vue&type=style&index=0&id=1b11b794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b11b794",
  null
  
)

export default component.exports